import {axios} from './request'

export function postAction(url, parameter) {
    // console.log(`%c====================== request info ======================>`, 'color:blue')
    // console.log("url ===>",url)
    // console.log("param ===>",parameter)
    // console.log(`%c====================== request info ======================>`, 'color:blue')
    return axios({
        url: url,
        method: 'post',
        data: parameter
    })
}

//post method= {post | put}
export function httpAction(url, parameter, method) {
    return axios({
        url: url,
        method: method,
        data: parameter
    })
}

//put
export function putAction(url, parameter) {
    return axios({
        url: url,
        method: 'put',
        data: parameter,
    })
}

//get
export function getAction(url, parameter) {
    return axios({
        url: url,
        method: 'get',
        params: parameter
    })
}

//deleteAction
export function deleteAction(url, parameter) {
    return axios({
        url: url,
        method: 'delete',
        params: parameter
    })
}
